/* src/components/utils/rutUtils.js - Modificado el 04-02-2026 */
/* ------------- normalización estándar de RUT --------------- */

export const normalizeRut = (rut) => {
  if (!rut || typeof rut !== "string") return "";

  return rut
    .replace(/\./g, "")
    .replace("-", "")
    .trim()
    .padStart(10, "0")
    .toUpperCase();
};
